import routes from '../../../router.js';
import testPlaceSelect from './testPlaceSelect.js';

function selectPlace(sessionId, placeId) {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV == 'dev') {
      const response = {
        places: testPlaceSelect.places,
        selected: testPlaceSelect.sold.includes(placeId) ? false : true,
      };
      setTimeout(function() {
        resolve(response);
      }, 500);
    } else {
      const headers = {
        headers: {
          Accept: 'application/json',
        },
        method: 'GET',
      };

      fetch(`${routes.buy.places}?id=${sessionId}`, headers)
        .then(response => response.json())
        .then(json => {
          if (json.places) {
            resolve({
              selected: json.sold.includes(placeId) ? false : true,
              places: json.places,
            });
          } else {
            reject(new Error(`Ошибка загрузки мест сеанса: ${json.errors}`));
          }
        })
        .catch(() => {
          reject(new Error(`Ошибка загрузки мест сеанса`));
        });
    }
  });
}

export default selectPlace;
